import { useCallback, useState, useRef } from 'react';
import { MediaType } from '../types';

export interface DropzoneProps {
  /** Callback to handle file uploads */
  onUpload?: (files: FileList) => void;
  children: React.ReactNode;
  disabled?: boolean;
  acceptedFileTypes?: MediaType[];
}

export const Dropzone = ({
  onUpload,
  children,
  disabled = false,
}: DropzoneProps) => {
  const [isDragOver, setIsDragOver] = useState(false);
  const dragCounter = useRef<number>(0);

  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current++;

    // Only show overlay if dragging files from outside
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setIsDragOver(true);
    }
  };

  const handleDragOver = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    if (!disabled) {
      setIsDragOver(true);
    }
  }, [disabled]);

  const handleDragLeave = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    dragCounter.current--;

    if (dragCounter.current === 0) {
      setIsDragOver(false);
    }
  }, []);

  const handleDrop = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
    dragCounter.current = 0;

    if (disabled) return;

    const files = e.dataTransfer.files;
    if (files && files.length > 0 && onUpload) {
      onUpload(files);
    }
  }, [disabled, onUpload]);

  // const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const files = event.target.files;
  //   if (files && files.length > 0 && onUpload) {
  //     onUpload(files);
  //     // Reset the input so the same file can be selected again
  //     event.target.value = '';
  //   }
  // };

  return (
    <>
      <div
        onDragEnter={handleDragEnter}
        onDragOver={handleDragOver}
        onDragLeave={handleDragLeave}
        onDrop={handleDrop}
        className={`dropzone ${isDragOver ? 'dropzone--active' : ''} ${disabled ? 'dropzone--disabled' : ''}`}
      >
        <div className="dropzone-children-container">
          {children}
        </div>
        {isDragOver &&
          (
            <div className="dropzone-area"></div>
          )
        }
      </div>
    </>
  );
};